import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Perspective',
  slug: 'perspective',
  category: 'Perspective',
  date: '2025-04-30',
  image: 'https://dpnelson.com/wp-content/uploads/2025/04/blogs-3.webp',
  excerpt: 'When a situation feels overwhelming, emotions can get in the way of progress. Try this. Step outside the situation and look at it from above…',
  body: `When a situation feels overwhelming, emotions can get in the way of progress.

Try this.

Step outside the situation and look at it from above. Try to see the problem at hand without the emotion. Sure, there's work to be done. But by looking at it from the outside, you'll have more power to address what you need to and let go of what you can't control.

There's peace in there – owning responsibility for and doing what you can do, and letting go of what you can't do anything about.`,
}

export default post
